export const Products = {
    English: "Imagine Language and Literacy",
    Spanish: "Imagine Español"
}

export const getProductAcronym = (product) => {
    switch( product )
    {
        case Products.English:
        {
            return "ILL";
        }
        case Products.Spanish:
        {
            return "IE";
        }
        default:
        {
            return "Unknown Product";
        }
    }
}

export const getProductFromAcronym = (product) => {
    switch( product )
    {
        case "ILL":
        {
            return Products.English;
        }
        case "IE":
        {
            return Products.Spanish;
        }
        default:
        {
            return "";
        }
    }
}


// WEBPACK FOOTER //
// ./src/constants/products.js